var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { ProtelService } from "../../../services/integrations/protel/protel.service";
import { EliteService } from "../../../services/integrations/elite/elite.service";
import { CasablancaService } from "../../../services/integrations/casablanca/casablanca.service";
import { FidelioService } from "../../../services/integrations/fidelio/fidelio.service";
import { GastrodatService } from "../../../services/integrations/gastrodat/gastrodat.service";
export var useAllIntegrations = function () {
    var _a, _b, _c, _d, _e;
    var protelQuery = useQuery(['allProtelConfigs'], function () {
        return ProtelService.getAll({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    var protelConfigs = (((_a = protelQuery.data) === null || _a === void 0 ? void 0 : _a.content) || []).map(function (config) {
        return __assign(__assign({}, config), { fullName: config.name + " [Protel]" });
    });
    var eliteQuery = useQuery(['allEliteConfigs'], function () {
        return EliteService.getAll({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    var eliteConfigs = (((_b = eliteQuery.data) === null || _b === void 0 ? void 0 : _b.content) || []).map(function (config) {
        return __assign(__assign({}, config), { fullName: config.name + " [Elite]" });
    });
    var casablancaQuery = useQuery(['allCasablancaConfigs'], function () {
        return CasablancaService.getAll({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    var casablancaConfigs = (((_c = casablancaQuery.data) === null || _c === void 0 ? void 0 : _c.content) || []).map(function (config) {
        return __assign(__assign({}, config), { fullName: config.name + " [Casablanca]" });
    });
    var fidelioQuery = useQuery(['allFidelioConfigs'], function () {
        return FidelioService.getAll({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    var fidelioConfigs = (((_d = fidelioQuery.data) === null || _d === void 0 ? void 0 : _d.content) || []).map(function (config) {
        return __assign(__assign({}, config), { fullName: config.name + " [Fidelio]" });
    });
    var gastrodatQuery = useQuery(['allGastrodatConfigs'], function () {
        return GastrodatService.getAll({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    var gastrodatConfigs = (((_e = gastrodatQuery.data) === null || _e === void 0 ? void 0 : _e.content) || []).map(function (config) {
        return __assign(__assign({}, config), { fullName: config.name + " [Gastrodat]" });
    });
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], protelConfigs, true), eliteConfigs, true), casablancaConfigs, true), fidelioConfigs, true), gastrodatConfigs, true);
};
